import React, { useEffect, useRef } from "react";
import Markdown from "markdown-to-jsx";

import ChatIcon from "./assets/chat-icon.svg";
import LoadingIcon from "./assets/loading-icon.svg";

import { getText } from "../../helpers";

export default function ChatbotPrompt({ controller }) {
  const contentDivRef = useRef(null);

  useEffect(() => {
    // always scroll to bottom when new conversation is added
    contentDivRef.current && contentDivRef.current.scrollTo({ top: contentDivRef.current.scrollHeight });
  }, [controller.conversations]);

  return (
    <div className="conversation-content" ref={contentDivRef}>
      {controller.conversations.length === 0 && <div className="text-muted">{getText("No conversations yet")}</div>}
      {controller.conversations.map(({ role, content, isError }, idx) => {
        const messageClass = `conversation-content-message ${isError? "conversation-content-error": ""}`
        return (
          <div key={idx} className={`conversation-content-box ${role}`}>
            {role === "user" ? (
              <div className="conversation-content-label">{getText("You")}:</div>
            ) : (
              <div className="conversation-content-label">
                <img src={ChatIcon} alt="" height="100%"></img>
                <span>{getText("AI Chatbot")}:</span>
              </div>
            )}
            <div className={messageClass}>
              <Markdown>{content}</Markdown>
            </div>
          </div>
        );
      })}
      {controller.isLoading ? (
        <div className="loader-indicator">
          <img src={LoadingIcon} alt="" height="100%"></img>
        </div>
      ) : null}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/chatbot/chatbot_prompts.js